import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPostcard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="postcard-2, address"><path d="M6.75 10.25H9.25M6.75 13.75H9.25M2.75 4.75H21.25V19.25H2.75V4.75ZM12.75 9.75H17.25V14.25H12.75V9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPostcard2;
